function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 56,
  r: 56,
  fill: "#D7F6EE"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.88 51C56.7417 51 52.9249 51.674 50.0887 52.818C47.3696 53.9149 45.04 55.6784 45.04 58.0532C45.04 58.2355 45.0538 58.4142 45.0804 58.5893C45.054 58.6835 45.04 58.7818 45.04 58.883V82.046C45.04 84.5754 47.2183 86.5833 50.0142 87.886C52.8683 89.2158 56.7124 90 60.88 90C65.0476 90 68.8918 89.2158 71.7459 87.886C74.5418 86.5833 76.72 84.5754 76.72 82.046V58.883C76.72 58.7818 76.7061 58.6835 76.6797 58.5893C76.7063 58.4142 76.72 58.2355 76.72 58.0532C76.72 55.6784 74.3905 53.9149 71.6713 52.818C68.8352 51.674 65.0184 51 60.88 51ZM73.84 65.5213V62.1996C73.1775 62.615 72.44 62.9783 71.6713 63.2883C68.8352 64.4323 65.0184 65.1064 60.88 65.1064C56.7417 65.1064 52.9249 64.4323 50.0887 63.2883C49.3201 62.9783 48.5826 62.615 47.92 62.1996V65.5213C47.92 66.6712 48.9546 68.0013 51.3751 69.1171C53.7338 70.2045 57.0917 70.9149 60.88 70.9149C64.6684 70.9149 68.0263 70.2045 70.385 69.1171C72.8055 68.0013 73.84 66.6712 73.84 65.5213ZM47.92 70.1199C48.5551 70.5668 49.2654 70.9659 50.0198 71.3136C52.8727 72.6288 56.7148 73.4043 60.88 73.4043C65.0453 73.4043 68.8874 72.6288 71.7403 71.3136C72.4946 70.9659 73.205 70.5668 73.84 70.1199V73.8191C73.84 74.969 72.8055 76.2992 70.385 77.415C68.0263 78.5024 64.6684 79.2128 60.88 79.2128C57.0917 79.2128 53.7338 78.5024 51.3751 77.415C48.9546 76.2992 47.92 74.969 47.92 73.8191V70.1199ZM47.92 82.046V78.4178C48.5551 78.8647 49.2654 79.2637 50.0198 79.6115C52.8727 80.9267 56.7148 81.7021 60.88 81.7021C65.0453 81.7021 68.8874 80.9267 71.7403 79.6115C72.4946 79.2637 73.205 78.8647 73.84 78.4178V82.046C73.84 83.2224 72.7951 84.5692 70.3794 85.6947C68.0219 86.7931 64.666 87.5106 60.88 87.5106C57.094 87.5106 53.7382 86.7931 51.3807 85.6947C48.965 84.5692 47.92 83.2224 47.92 82.046ZM47.92 58.0532C47.92 57.2201 48.8141 56.0793 51.3067 55.0739C53.6823 54.1156 57.0655 53.4894 60.88 53.4894C64.6946 53.4894 68.0778 54.1156 70.4534 55.0739C72.946 56.0793 73.84 57.2201 73.84 58.0532C73.84 58.8863 72.946 60.0271 70.4534 61.0325C68.0778 61.9908 64.6946 62.617 60.88 62.617C57.0655 62.617 53.6823 61.9908 51.3067 61.0325C48.8141 60.0271 47.92 58.8863 47.92 58.0532Z",
  fill: "#0A0806"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1129 25.66C62.8313 26.8982 62.6891 28.8893 61.1253 31.3936C59.6017 33.8334 56.9148 36.4071 53.3892 38.4525C49.8636 40.4978 46.2957 41.5529 43.4213 41.6645C40.4711 41.779 38.672 40.9142 37.9537 39.6759C37.2353 38.4377 37.3776 36.4467 38.9414 33.9424C40.4649 31.5025 43.1519 28.9288 46.6774 26.8834C50.203 24.8381 53.771 23.783 56.6453 23.6715C59.5955 23.557 61.3946 24.4218 62.1129 25.66Z",
  stroke: "#0A0806",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M65.8411 31.5916L67.1386 30.8388L67.1304 30.8247L67.1219 30.8108L65.8411 31.5916ZM41.9041 45.6769L43.2016 44.9242L43.1731 44.875L43.1409 44.8282L41.9041 45.6769ZM63.5156 24.8951C63.0843 24.1877 62.1614 23.9639 61.454 24.3951C60.7467 24.8263 60.5228 25.7493 60.954 26.4566L63.5156 24.8951ZM39.3588 39.3172C38.8901 38.6341 37.9563 38.4604 37.2733 38.9292C36.5902 39.3979 36.4165 40.3317 36.8853 41.0147L39.3588 39.3172ZM64.5436 32.3443C65.1595 33.4059 65.0994 35.1371 63.7891 37.3386C62.5094 39.4885 60.1861 41.7827 56.9982 43.6321L58.5037 46.227C62.0431 44.1736 64.7772 41.5438 66.367 38.873C67.9261 36.2536 68.5474 33.2673 67.1386 30.8388L64.5436 32.3443ZM56.9982 43.6321C53.7992 45.488 50.5754 46.4554 47.9934 46.5772C45.3274 46.703 43.7898 45.9381 43.2016 44.9242L40.6067 46.4297C42.0432 48.9058 45.0654 49.7186 48.1348 49.5739C51.2882 49.4252 54.9755 48.2739 58.5037 46.227L56.9982 43.6321ZM67.1219 30.8108L63.5156 24.8951L60.954 26.4566L64.5603 32.3723L67.1219 30.8108ZM43.1409 44.8282L39.3588 39.3172L36.8853 41.0147L40.6674 46.5257L43.1409 44.8282Z",
  fill: "#0A0806"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 120,
  height: 120,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

const SvgFees = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFees, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fees.1a1f959a.svg";
export { ForwardRef as ReactComponent };